// extracted by mini-css-extract-plugin
export default {"mainHeader":"AboutSummary_mainHeader__3j1Is","subLink":"AboutSummary_subLink__OaW0C"};